import _ from "lodash";

export const emptyFilters = {
  createdAt: null,
  userId: null,
  userName: null,
};

export const multipleFilters = [];

export const defaultFilters = _.merge({}, emptyFilters, {});

export default {
  logs: [],
  count: 0,
  pagination: {
    page: 1,
    rowPerPage: 20,
  },
  sort: {
    sortBy: "createdAt",
    desc: true,
  },
  filters: _.merge({}, defaultFilters),
};
